import React from 'react';
import BaseComponent from 'apps/new-web/views/component';
import { createFooterlessLayout } from 'apps/new-web/views/pages/create-layout';
import { connect } from 'react-redux';
import ScrollWrapper from 'apps/new-web/views/components/scroll-context';
import ActivateSignUpNav from '../sign-up/components/activate-signup-nav';
import I18n from 'apps/new-web/views/components/i18n';
import DownloadContent from './components/download-content';

export class PureDownloadPage extends BaseComponent {
  static getAdditionalHeadTags() {
    return `<meta name="description" content="${ I18n.translate('Get personal virtual fitness training from experts, whether you have [ifit]-enabled equipment, your own equipment, or no equipment! Download [ifit] apps now.', { 'ifit': 'iFIT' }, 'Invites user to join iFIT.') }" />`;
  }

  render() {
    const embededData = {
      header: I18n.translate('You’re all set!', 'Title explaining the user is ready to start using their machine.'),
      primaryCopy: I18n.translate('To start using [ifit], sign in on your machine with the account that you just created.', { ifit: 'iFIT' }),
      secondaryHeader: I18n.translate('Want more?', 'Title asking the user if they want download the iFIT app.'),
      secondaryCopy: I18n.translate('Download the [ifit] app on your tablet or smartphone. That way, you can work out with [ifit], even when you\'re away from your machine.', { ifit: 'iFIT' }),
      appStoreiFitIcon: true,
    };

    return (
      <div className="download-app-page">
        <ScrollWrapper>
          <ActivateSignUpNav link="/" />
          <section
            aria-label={ I18n.translate('Download [ifit] apps.', { ifit: 'iFIT' }, 'Header announcing this is where the user will download the app.' ) }
            className="download-page-content"
          >
            <div className="scrim" />
            <DownloadContent data={ embededData } />
          </section>
        </ScrollWrapper>
      </div>
    );
  }
}

const DownloadPage = connect((state) => {
  return {
    layout: state.layout,
    brand: state.brand
  };
})(PureDownloadPage);

export default createFooterlessLayout(DownloadPage);
